export const dashboard = {
  pageHeader: 'Dashboard',
  filters: {
    dateRange: 'Date range'
  },
  noData: {
    header: 'No results found',
    body: 'Try changing the location or date range'
  },
  miniPanelApproved: 'JOBS APPROVED',
  miniPanelCancelled: 'CANCELLED SLOTS',
  miniPanelWithdrawn: 'WITHDRAWN SLOTS',
  miniPanelApprovedShort: 'APPROVED',
  miniPanelWithdrawnShort: 'WITHDRAWN',
  miniPanelCancelledShort: 'CANCELLED',
  fillRateByDateChartHeader: 'Fill Rate by Day',
  fillRateByVenueChartHeader: 'Fill Rate by Location',
  topWonoloersChartHeader: 'Top Wonoloer stats',
  wonoloersJobExperienceRatingsHeader: 'Wonoloers’ Job Experience Rating',
  totalSpendByJobChartHeader: 'Total Spend By Job',
  totalSpendByDayChartHeader: 'Total Spend By Day',
  repeatWonoloersChartHeader: 'Repeat Wonoloers',
  repeatWonoloersByDayChartHeader: 'New vs. Repeat Wonoloers',
  charts: {
    noResults: 'No results found in date range.',
    repeatWonoloersLabel: 'Repeat Wonoloers',
    repeatWonoloersByDayLabel: 'REPEAT',
    newWonoloersByDayLabel: 'NEW',
    repeatWonoloersByDayXAxis: 'New Wonoloers',
    newWonoloersLabel: 'New Wonoloers',
    repeatWonoloersXAxis: 'Job Name',
    repeatWonoloersYAxis: 'Number of Wonoloers',
    repeatWonoloersByDayYAxis: 'TOTAL WONOLOERS',
    spendByDayXAxis: 'DATE',
    spendByDayYAxis: 'TOTAL SPEND',
    fillRateByDayXAxis: 'DATE',
    fillRateByDayYAxis: 'PERCENT FILLED',
    fillRateByVenueXAxis: 'LOCATION',
    fillRateByVenueYAxis: 'PERCENT FILLED',
    wonoloersJobExperienceRatingsXAxis: 'PERCENT OF RESPONDANTS',
  }
};
